// extracted by mini-css-extract-plugin
export default {"Menu":"style_Menu__GDZYV"};